var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox relative" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "ListFilterVue",
            {
              attrs: {
                initForm: _vm.initForm,
                FILTER_ITEMS: _vm.FILTER_ITEMS,
                handleSearch: _vm.handleSearch,
                "max-height": 168,
              },
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:export:excel:product"],
                      expression: "['admin:export:excel:product']",
                    },
                  ],
                  staticStyle: { "margin-right": "5px" },
                  attrs: { size: "mini", icon: "el-icon-upload2" },
                  on: { click: _vm.exports },
                },
                [_vm._v("\n          结果导出\n        ")]
              ),
              _vm._v(" "),
              _c(
                "router-link",
                { attrs: { to: { path: "/store/list/creatProduct" } } },
                [
                  _c(
                    "el-button",
                    {
                      directives: [
                        {
                          name: "hasPermi",
                          rawName: "v-hasPermi",
                          value: ["admin:product:save"],
                          expression: "['admin:product:save']",
                        },
                      ],
                      staticClass: "mr10",
                      staticStyle: { margin: "0px 10px" },
                      attrs: { size: "mini", type: "primary" },
                    },
                    [_vm._v("添加商品")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                "max-height": "600",
                "highlight-current-row": true,
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { label: "SPU ID", width: "70", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("div", [_vm._v(_vm._s(scope.row.id))]),
                        _vm._v(" "),
                        scope.row.hasDraft
                          ? _c("div", { staticClass: "text_box" }, [
                              _vm._v("草稿"),
                            ])
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { label: "商品图", width: "60", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview" },
                          [
                            _c("el-image", {
                              staticStyle: { width: "36px", height: "36px" },
                              attrs: {
                                src:
                                  scope.row.abbreviationImage ||
                                  scope.row.image,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.previewImg(scope.row.image)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "spuCode",
                  label: "SPU编码",
                  "min-width": "100",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "storeName",
                  label: "SPU名称",
                  "min-width": "90",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "cateValues",
                  label: "商品分类",
                  "min-width": "90",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "showCateValues",
                  label: "展示分类",
                  "min-width": "90",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productAreaValues",
                  label: "产地",
                  "min-width": "100",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "brandName",
                  label: "品牌",
                  width: "120",
                  align: "center",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "supplierName",
                  label: "供应商",
                  "min-width": "120",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "maintainerName",
                  label: "维护人",
                  "min-width": "120",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "isShow",
                  label: "上架状态",
                  width: "90",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-color": "#13ce66",
                            "active-text": "上架",
                            "inactive-text": "下架",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShow(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.isShow,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "isShow", $$v)
                            },
                            expression: "scope.row.isShow",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "sort",
                  label: "排序",
                  width: "80",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-input", {
                          attrs: { size: "small" },
                          on: {
                            input: function ($event) {
                              return _vm.inputSort(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.sort,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "sort", $$v)
                            },
                            expression: "scope.row.sort",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "verifyName",
                  label: "审核状态",
                  width: "100",
                  "show-overflow-tooltip": true,
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        scope.row.isVerify == 1
                          ? _c("span", { staticStyle: { color: "#67C23A" } }, [
                              _vm._v(_vm._s(scope.row.verifyName)),
                            ])
                          : scope.row.isVerify == -1
                          ? _c(
                              "span",
                              { staticStyle: { color: "#F56C6C" } },
                              [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(scope.row.verifyName) +
                                    "\n              "
                                ),
                                _c(
                                  "el-popover",
                                  {
                                    attrs: {
                                      trigger: "hover",
                                      placement: "top",
                                    },
                                  },
                                  [
                                    _c("p", [
                                      _vm._v(
                                        "失败原因: " +
                                          _vm._s(scope.row.verifyReason)
                                      ),
                                    ]),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticStyle: { color: "#E6A23C" },
                                        attrs: { slot: "reference" },
                                        slot: "reference",
                                      },
                                      [
                                        _vm._v(
                                          "\n                  原因\n                  "
                                        ),
                                        _c("i", {
                                          staticClass:
                                            "el-icon-warning-outline",
                                        }),
                                      ]
                                    ),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _c("span", { staticStyle: { color: "#409EFF" } }, [
                              _vm._v(_vm._s(scope.row.verifyName)),
                            ]),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "140",
                  align: "center",
                  "show-overflow-tooltip": true,
                },
              }),
              _vm._v(" "),
              _vm.userType !== 2
                ? _c("el-table-column", {
                    attrs: {
                      prop: "createdName",
                      label: "操作人",
                      "min-width": "100",
                      align: "center",
                      "show-overflow-tooltip": true,
                    },
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "150",
                  fixed: "right",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:product:update"],
                                expression: "['admin:product:update']",
                              },
                            ],
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.editGoods(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.auditItem(
                                  scope.row.id,
                                  scope.row.isVerify,
                                  scope.row.verifyReason
                                )
                              },
                            },
                          },
                          [_vm._v("审核")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.priceAdjustmentItem(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("调价记录")]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            directives: [
                              {
                                name: "hasPermi",
                                rawName: "v-hasPermi",
                                value: ["admin:product:delete"],
                                expression: "['admin:product:delete']",
                              },
                            ],
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDelete(
                                  scope.row.id,
                                  _vm.tableFrom.type
                                )
                              },
                            },
                          },
                          [_vm._v("删除")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "block" },
            [
              _c("el-pagination", {
                attrs: {
                  "page-sizes": [20, 40, 60, 80],
                  "page-size": _vm.pageData.limit,
                  "current-page": _vm.pageData.page,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("AuditSpuOrSku", {
        ref: "auditSpuOrSkuRef",
        on: { auditEdit: _vm.getList },
      }),
      _vm._v(" "),
      _c("PriceAdjustment", { ref: "priceAdjustmentItemRef" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }